<!--通讯监测页面查询-->
<template>
	<div style="width: 100%;height: 100%;display: flex;">
		<div class="channelContainer custom-scrollbar">
			<div v-for="(item,i) in channelList" :key="'channel'+i" class="channelLi" @click="nowChannel = item">
				<p class="channelName">{{item.name}}</p>
				<div class="channelState">
					<p class="stateOff" v-show="item.channelstate == 0">中断</p>
					<p class="stateOn" v-show="item.channelstate == 1">正常</p>
				</div>
			</div>
		</div>
		<div class="deviceContainer custom-scrollbar">
			<div v-for="(item,i) in deviceList" :key='i' class="deviceLi" @click="deviceClick(item)">
				<div class="deviceName flexBetween">
					<p class="betweenLeft">设备名称</p><p class="betweenRight">{{item.name}}</p>
				</div>
				<div class="deviceInfos">
					<div class="flexBetween">
						<p class="betweenLeft">状态<span class="deviceStateOff" v-show="item.devicestate == 0"></span><span class="deviceStateOn" v-show="item.devicestate == 1"></span></p>
						<p class="betweenRight">投运状态
							<img v-show="item.run == 1" :src="$store.resourcesStore.getters.getResourcesByName('channel/state_on.png')" alt="" />
							<img v-show="item.run == 0" :src="$store.resourcesStore.getters.getResourcesByName('channel/state_off.png')" alt="" />
						</p>
					</div>
					<p>设备地址&#x3000;{{item.deviceaddr}}</p>
					<p>扩展地址&#x3000;{{item.deviceaddr1}}</p>
					<div class="flexBetween">
						<p class="betweenLeft">重复次数&#x3000;{{item.resendcount}}</p>
						<p class="betweenRight">中断次数&#x3000;{{item.breakcount}}</p>
					</div>
					<p>协议&#x3000;{{item.protocol}}</p>
				</div>
			</div>
		</div>
		<deviceVariableListDialog ref="deviceVariableListDialog"></deviceVariableListDialog>
	</div>
</template>

<script>
	import deviceVariableListDialog from './deviceVariableListDialog.vue'
	export default {
		components: {
			deviceVariableListDialog
		},
		props: {},
		data() {
			return {
				nowChannel: undefined,
				nowDevice: undefined,
				nowVariable: undefined,
				channelList: [],
				deviceList: [],
			}
		},
		created() {},
		mounted() {
			debugPage = this
			this.getChannelList()
		},
		destroyed() {},
		computed: {
			nowPage() {
				var list = this.orderListByIndex[this.nowIndex]
				if(list == undefined) {
					return []
				}
				return list
			},
		},
		watch: {
			nowChannel(nv, ov) {
				this.getDeviceList()
			},
		},
		methods: {
			getAllUserList(list) {
				var resultList = []
				for(var i = 0, len = list.length; i < len; i++) {
					var item = list[i]
					if(item.type == 'PcmUser') {
						resultList.push(item)
					} else {
						//递归找下级
						resultList.addAll(this.getAllUserList(item.next))
					}
				}
				return resultList
			},
			getChannelList() {
				var pageIndex = 1
				var pageSize = 100
				this.$api.channelApi.getChannelLimit(pageIndex, pageSize, respon => {
					this.channelList = respon.data
					this.nowChannel = respon.data[0]
				})
			},
			getDeviceList() {
				var pageIndex = 1
				var pageSize = 100
				this.$api.channelApi.getDeviceByChannelLimit(this.nowChannel.no, pageIndex, pageSize, respon => {
					this.deviceList = respon.data
					this.nowDevice = respon.data[0]
				})
			},
			deviceClick(device){
				this.nowDevice = device
				this.$refs.deviceVariableListDialog.open('['+device.name+'] 变量实时值列表', device)
			},
		}
	}
</script>

<style scoped>
	.channelContainer{
		height: 100%;
		width: 190px;
		background-color: #FFFFFF;
		margin-right: 10px;
		display: flex;
		flex-wrap: wrap;
		align-content: flex-start;
		justify-content: center;
	}
	
	.channelLi{
		width: 140px;
		height: 110px;
		background-color: #E5E5E5;
		margin-top: 10px;
		border-radius: 5px;
	}
	
	.channelName{
		font-size: .18rem;
		line-height: 50px;
		text-align: center;
	}
	
	.channelState{
		display: flex;
		justify-content: center;
	}
	
	.channelState>P{
		margin-top: 20px;
	}
	
	.stateOn{
		color: #FFFFFF;
		line-height: 24px;
		padding: 0 10px;
		border-radius: 4px;
		background-color: #008000;
	}
	
	.stateOff{
		color: #FFFFFF;
		line-height: 24px;
		padding: 0 10px;
		border-radius: 4px;
		background-color: #F56161;
	}
	
	.deviceContainer{
		width: calc(100% - 200px);
		background-color: #FFFFFF;
		padding: 10px 0;
		display: flex;
		flex-wrap: wrap;
		align-content: flex-start;
	}
	
	.deviceLi{
		width: calc(20% - 22px);
		margin: 10px;
		border: solid 1px #E4E4E4;
		border-radius: 5px;
		overflow: hidden;
	}
	
	.deviceName{
		background-color: #3E9AF8;
		height: 42px;
		padding: 0 10px;
	}
	
	.deviceName>p{
		font-size: .16rem;
		color: #FFFFFF;
	}
	
	.betweenLeft{
		width: calc(55% - 5px);
	}
	
	.betweenRight{
		width: calc(45% - 5px);
		display: flex;
		align-items: center;
	}
	
	.betweenRight>img{
		width: 14px;
		height: 14px;
		margin-left: 10px;
	}
	
	.deviceInfos{
		padding: 0 10px;
	}
	
	.deviceInfos p{
		line-height: 30px;
		color: #616161;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	
	.deviceStateOff{
		display: inline-block;
		width: 12px;
		height: 12px;
		border-radius: 50%;
		background-color: #F56161;
		margin-left: 10px;
	}
	
	.deviceStateOn{
		display: inline-block;
		width: 12px;
		height: 12px;
		border-radius: 50%;
		background-color: green;
		margin-left: 10px;
	}
	
	@media screen and (max-width:1600px) {
		.deviceLi{
			width: calc(25% - 22px);
		}
	}
</style>